<script>
export default {
    data: function(){
        return  {
            packageSelected:false,
            amount: 0
        };
    },
    mounted: function(){
        $('#pay').attr('disabled',true);
    },
    methods: {
        selectPackage: function(amount){
            this.packageSelected = true;
            this.amount = amount
        },
        leaving: function () {

        }

    }
};

</script>
